import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ReportService } from "../../../../Report/report.service";
import { DataService_Attendance } from "../../shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-student-print-attendance",
	templateUrl: "./student-print-attendance.component.html",
	styleUrls: ["./student-print-attendance.component.css"],
})
export class StudentPrintAttendanceComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private reportService: ReportService
	) {}

	ngOnInit(): void {
		this.user = this.dialogConfig.data.user;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.SelectedPerson = this.dialogConfig.data.SelectedPerson;

		this.StartDate = this.dialogConfig.data.StartDate;
		this.EndDate = this.dialogConfig.data.EndDate;

		//this.StartDate.setFullYear(this.EndDate.getFullYear() - 1);
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////
	errorMessage: any = "";

	user: any;
	SchoolID: any;
	SelectedPerson: any;

	//Form
	StartDate: Date = new Date();
	EndDate: Date = new Date();
	ReportTypeOption: any = "Daily";

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	isProcessing: any = false;

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////
	onPrintAttendance() {
		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: StartDate
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 3: EndDate
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		var reportID = -1;
		if (this.ReportTypeOption == "Daily") {
			reportID = 207;

			//Parameter 4: SortOrder
			strParam += ",ASC|sortOrder";
		}
		if (this.ReportTypeOption == "Summary") {
			reportID = 208;
		} else if (this.ReportTypeOption == "Y2Y") {
			reportID = 209;
		}

		var result = this.reportService.Print(reportID, strParam, this.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////////
}
